import { Enlace } from '../../navegacion/Enlace.js'
import type { DestinoNavegacion } from './modeloNavegacion.js'
import styles from './EnlaceNavegacion.module.css'

export function EnlaceNavegacion({
  destino,
  compacto = false,
  onNavegar,
}: {
  destino: DestinoNavegacion
  compacto?: boolean
  onNavegar: () => void
}) {
  return (
    <Enlace
      vista={destino.vista}
      className={styles.link}
      data-compact={compacto}
      aria-current={destino.activo ? 'page' : undefined}
      onClick={onNavegar}
    >
      {destino.etiqueta}
    </Enlace>
  )
}
